module.exports = __webpack_public_path__ + "static/media/LogoCircleWhite.cb17485f.jpg";